import { render, staticRenderFns } from "./SkipBackIcon.vue?vue&type=template&id=13ea5d2e&"
import script from "./SkipBackIcon.vue?vue&type=script&lang=js&"
export * from "./SkipBackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports